import React from 'react';
import Img from 'graphcms-image';

import Paragraph from './renderers/Paragraph';
import Heading from './renderers/Heading';
import CardCTA from './CardCTA';
import CardLink from './CardLink';

const DefaultCard = ({
  coverImage,
  externalUrl,
  linkPath,
  id,
  subTitle,
  truncatedSubTitle,
  title,
}) => (
  <article className="flex flex-1" key={id}>
    <CardLink externalUrl={externalUrl} linkPath={linkPath}>
      {coverImage && (
        <div className="mb-2">
          <Img
            className="rounded-lg"
            image={coverImage}
            maxWidth={480}
            transforms={['quality=value:75']}
            withWebp
          />
        </div>
      )}
      <div className="-mt-6">
        <Heading children={title} level={4} className="mb-2" />
      </div>
      <Paragraph className="flex-grow">
        {truncatedSubTitle || subTitle}
      </Paragraph>
      <div className="flex items-center">
        <CardCTA label="Learn More" />
      </div>
    </CardLink>
  </article>
);

export default DefaultCard;
